// @ts-nocheck
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getPaykuBanks, postPaykuWithdrawal} from "../../services/wallet/payku.service";

export const usePostPaykuWithdrawal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postPaykuWithdrawal,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWallet"]});
    },
    onError: _error => {},
  });
};

export const useGetPaykuBanks = currency => {
  return useQuery({
    queryKey: ["paykuBanks", currency],
    queryFn: () => getPaykuBanks(currency),
    enabled: !!currency,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
